import React from 'react';
import {QcJobStatuses} from '@pluto/@types';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import './QCStatusToggle.scss';

type StatusChanged = (event: React.MouseEvent<HTMLElement>, newStatus: QcJobStatuses) => void;

export interface QCStatusToggleProps {
    onStatusChange: StatusChanged;
    status: QcJobStatuses;
}

export default function QCStatusToggle(props: QCStatusToggleProps) {
    const {
        onStatusChange,
        status,
    } = props;
    
    return (
        <ToggleButtonGroup
            value={status}
            exclusive
            onChange={onStatusChange}
            aria-label="QC status"
        >
            <ToggleButton
                value={QcJobStatuses.Passed}
                aria-label="QC passed"
                className="pass-button"
            >
                QC Passed
            </ToggleButton>
            <ToggleButton
                value={QcJobStatuses.Failed}
                aria-label="QC failed"
                className="fail-button"
            >
                QC Failed
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
